/* eslint-disable import/prefer-default-export */
import _ from 'lodash';
import { getForm } from '../../../utils/reducerHalpers/formFields';
import { createReducerDotPathName } from './naming';

const getState = (state, reducerName) =>
  _.get(state, createReducerDotPathName(reducerName));

export const selectState = (state, reducerName) => getState(state, reducerName);

export const selectFormBody = (state, reducerName) =>
  getForm(getState(state, reducerName));

export const selectFieldActivationCode = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.activation_code');

export const selectResultObject = (state, reducerName) =>
  _.get(getState(state, reducerName), 'resultObject');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/complaints/addComplaintForm/selectors.js